import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 verify_resign_in_otp: { message: "idle" },
};

export const verify_resign_in_otp_Slice = createSlice({
 name: "verify_resign_in_otp",
 initialState,
 reducers: {
  success_verify_resign_in_otp: (state, action) => {
   const { token, profiles } = action?.payload;
   const tenant_val = action?.payload?.tenant_token;
   const token_2 = tenant_val?.token;
   const { tenant } = tenant_val;

   // Process Profiles to Get Module Name
   let module_name;

   if (profiles?.length === 1)
   {
    const def_prof = profiles[0];

    module_name = def_prof?.module_name;
   }
   else
   {
    // Find Where Default Profile is Equal to True
    const def_prof = profiles?.find((profile) => profile?.default_profile === true);

    module_name = def_prof?.module_name;
   }

   localStorage.setItem('profile_access', JSON.stringify(token));
   localStorage.setItem('user_account', JSON.stringify(profiles));
   localStorage.setItem('dashboard_tenant', JSON.stringify(tenant));
   if (!localStorage.getItem("module_name"))
   {
    localStorage.setItem('module_name', JSON.stringify(module_name));
   }
   localStorage.setItem('dashboard_access', JSON.stringify(token_2));
   state.verify_resign_in_otp = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_verify_resign_in_otp: (state, action) => {
   state.verify_resign_in_otp = { status: app_consts.FAIL, message: action.payload };
  },
  reset_verify_resign_in_otp: (state) => {
   state.verify_resign_in_otp = { status: app_consts.IDLE };
  },
  loading_verify_resign_in_otp: (state) => {
   state.verify_resign_in_otp = { status: app_consts.LOADING };
  },
 }
});

export const { success_verify_resign_in_otp, fail_verify_resign_in_otp, reset_verify_resign_in_otp, loading_verify_resign_in_otp } = verify_resign_in_otp_Slice.actions;

export default verify_resign_in_otp_Slice.reducer;